import * as React from 'react';
import { Outlet , useNavigate} from 'react-router-dom';

import LogoutIcon from '@mui/icons-material/Logout';
import { 
    Box,
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Button
 } from '@mui/material';
 
import { Confirmation } from '../utils';
import { CONST, TokenValidator } from '../../utils';
import NavigationActions from '../navigationActions';

 export default function Holder() {
    document.title = 'Order Tracker';

    return(
        <Box>
            <AppBar 
                position="static"
            >
                <Toolbar
                    sx={{
                        gap: 2
                    }}
                >
                <NavigationActions />

                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    ORDER TRACKER
                </Typography>

                </Toolbar>
            </AppBar>

            <Outlet />
        </Box>
    );
}
